import {
  Button,
  ButtonWidth,
  IconStar,
  pluralize,
  Rating,
  RatingSize,
} from '@leland-dev/leland-ui-library';
import React from 'react';

import ReviewDimension from './ReviewDimension';

interface ReviewInfoProps {
  reviewTotal?: number;
  averageReviewRate: number;
  averageKnowledgeReviewRate?: number;
  averageResponsivenessReviewRate?: number;
  averageSupportivenessReviewRate?: number;
  averageValueReviewRate?: number;
  onLeaveAReview?: () => void;
  showReviewButton?: boolean;
}

const ReviewInfo: React.FC<ReviewInfoProps> = ({
  reviewTotal,
  averageReviewRate,
  averageKnowledgeReviewRate,
  averageResponsivenessReviewRate,
  averageSupportivenessReviewRate,
  averageValueReviewRate,
  onLeaveAReview,
  showReviewButton = false,
}) => {
  const hasReviewDimensions =
    (averageKnowledgeReviewRate ?? 0) +
      (averageResponsivenessReviewRate ?? 0) +
      (averageSupportivenessReviewRate ?? 0) +
      (averageValueReviewRate ?? 0) !==
    0;

  return (
    <div className="flex w-full flex-col space-y-6">
      {reviewTotal ? (
        <h2 className="text-left text-4xl font-medium text-leland-gray-dark">
          {pluralize(reviewTotal, 'Review')}
        </h2>
      ) : null}
      <div className="flex w-full flex-col">
        <p className="font-medium text-leland-gray-light">Overall Rating</p>
        <div className="flex items-center">
          <h2 className="mr-3 text-4xl font-medium text-leland-gray-dark">
            {averageReviewRate.toFixed(1)}
          </h2>
          <Rating
            rate={averageReviewRate}
            size={
              reviewTotal !== undefined ? RatingSize.MEDIUM : RatingSize.LARGE
            }
          />
        </div>
      </div>
      {hasReviewDimensions ? (
        <>
          <hr className="w-full" />
          <div className="space-y-3">
            <ReviewDimension
              rate={averageKnowledgeReviewRate}
              dimension="Knowledge"
            />
            <ReviewDimension rate={averageValueReviewRate} dimension="Value" />
            <ReviewDimension
              rate={averageResponsivenessReviewRate}
              dimension="Responsiveness"
            />
            <ReviewDimension
              rate={averageSupportivenessReviewRate}
              dimension="Supportiveness"
            />
          </div>
        </>
      ) : null}

      {showReviewButton && onLeaveAReview ? (
        <Button
          LeftIcon={IconStar}
          label="Leave a review"
          width={ButtonWidth.FULL}
          rounded
          onClick={onLeaveAReview}
          id="review_info:leave_review"
        />
      ) : null}
    </div>
  );
};

export default ReviewInfo;
